export const config = {
  serverURL: "https://production-api.laspezia.kitg.com.ua/",
  API: "https://production-api.laspezia.kitg.com.ua/admin/api",
  // ws: "wss://api.production.laspezia.kitg.com.ua/wss",
  imageProxy: "https://production-api.laspezia.kitg.com.ua/public/",
};
